if (!customElements.get("image-slider")) {
  class ImageSlider extends HTMLElement {
    constructor() {
      super();
      this.options = {
        effect: "cube",
        grabCursor: true,
        cubeEffect: {
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        autoPlay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      };
    }
    connectedCallback() {
      setTimeout(() => {
        const slider = new Swiper(this, this.options);
      }, 200);
    }
  }
  customElements.define("image-slider", ImageSlider);
}
